export default __webpack_public_path__ + "static/media/wordleapYoutubeSubtitle.51d36f64.gif";